import React from 'react';
import Modal from './Modal';

const ConfirmModal = ({ show, onClose, onConfirm, title, message, confirmText = "Confirm", cancelText = "Cancel", type = "primary" }) => {
    return (
        <Modal show={show} onClose={onClose} title={title}>
            <div className="text-center py-4">
                <div className={`mb-3 text-${type}`}>
                    {type === 'danger' && <i className="bi bi-exclamation-circle display-4"></i>}
                    {type === 'success' && <i className="bi bi-check-circle display-4"></i>}
                    {type === 'primary' && <i className="bi bi-info-circle display-4"></i>}
                    {type === 'warning' && <i className="bi bi-exclamation-triangle display-4"></i>}
                </div>
                <h5 className="mb-3">{title}</h5>
                <p className="text-muted mb-4">{message}</p>

                <div className="d-flex justify-content-center gap-3">
                    <button className="btn btn-light px-4 rounded-pill" onClick={onClose}>
                        {cancelText}
                    </button>
                    <button
                        className={`btn btn-${type === 'warning' ? 'warning text-white' : type} px-4 rounded-pill shadow-sm`}
                        onClick={() => {
                            onConfirm();
                            onClose();
                        }}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmModal;
